import React from 'react'
import cx from 'classnames'
import ProgressSpinner from 'components/ProgressSpinner'
import { observer } from 'mobx-react'
import './styles.sass'

const WizardFooter = ({ wizard }) => {
  const disabled = wizard.currentStep.nextEnabled !== true || wizard.isProcessing
  return (
    <div className="wizard-footer">
      <a
        href="#"
        className={cx(
          'button is-continue-button is-awesome has-chevron-right'
        )}
        onClick={!disabled && ((e) => e.preventDefault() || wizard.next())}
        disabled={disabled}
      >
        {wizard.isProcessing
          ? <ProgressSpinner />
          : (
            wizard.currentStep.continueButtonText || 'Continue'
          )
        }
      </a>
    </div>
  )
}

export default observer(WizardFooter)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/WizardFooter/index.jsx